<script setup>
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import ColorField from '../../fields/ColorField.vue';
import SpacingField from '../../fields/SpacingField.vue';
import SliderField from '../../fields/SliderField.vue';

const props = defineProps({ node: { type: Object, required: true } });
const emit = defineEmits(['update']);
const ed = inject('emailEditor');
const { t } = useI18n();
const theme = computed(() => ed.template.value?.theme || {});
const st = computed(() => props.node.style || {});
const style = (key, value) => emit('update', { style: { [key]: value } }, key);
const border = (key, value) =>
  style('border', {
    width: 1,
    color: '#e6e9ee',
    sides: 'all',
    ...(st.value.border || {}),
    [key]: value,
  });
</script>

<template>
  <div data-props="column" class="flex flex-col gap-4">
    <ColorField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.BACKGROUND')"
      :theme="theme"
      allow-none
      :model-value="st.background"
      @update:model-value="v => style('background', v)"
    />
    <SpacingField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.PADDING')"
      :model-value="st.padding"
      @update:model-value="v => style('padding', v)"
    />
    <SliderField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.RADIUS')"
      :model-value="st.radius || 0"
      :min="0"
      :max="60"
      unit="px"
      @update:model-value="v => style('radius', v)"
    />
    <SliderField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.BORDER_WIDTH')"
      :model-value="st.border?.width || 0"
      :min="0"
      :max="10"
      unit="px"
      @update:model-value="
        v => (v ? border('width', v) : style('border', null))
      "
    />
    <ColorField
      v-if="st.border?.width"
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.BORDER_COLOR')"
      :theme="theme"
      :model-value="st.border.color"
      @update:model-value="v => border('color', v)"
    />
    <label class="flex flex-col gap-1.5">
      <span class="text-xs font-medium text-n-slate-11">{{
        t('EMAIL_TEMPLATES.EDITOR.PROPS.VALIGN')
      }}</span>
      <select
        class="rounded-lg border border-n-weak bg-n-solid-1 px-2 py-1.5 text-sm"
        :value="node.valign"
        @change="emit('update', { valign: $event.target.value }, 'valign')"
      >
        <option v-for="v in ['top', 'middle', 'bottom']" :key="v" :value="v">
          {{ t(`EMAIL_TEMPLATES.EDITOR.PROPS.VALIGN_OPTIONS.${v}`) }}
        </option>
      </select>
    </label>
  </div>
</template>
